module.exports = __webpack_public_path__ + "static/img/zixun_011.de68a79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zixun_011.png
// module id = 4lUV
// module chunks = 1